var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "z-index": "2",
      "background-color": "#000"
    },
    style: _vm.vertical ? 'aspect-ratio: 9 / 16; left: 5.9%; top: 11%; width: 88.5%;' : 'aspect-ratio: 16 / 9; left: 11%; top: 4.8%; width: 78%;'
  }, [_vm._t("default")], 2), _c('img', {
    staticStyle: {
      "position": "relative",
      "z-index": "1",
      "pointer-events": "none"
    },
    style: {
      'aspect-ratio': _vm.vertical ? '355 / 720' : '720 / 355'
    },
    attrs: {
      "width": "100%",
      "src": `https://cdn.ellacard.com/start/mobile-outline${_vm.vertical ? '-vertical' : ''}.png`
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }